import './PlusButtonDropdown.css';

interface PlusButtonDropdownProps {
  visible: boolean;
  onNewMatterClick: () => void;
  onNoteClick: () => void;
  onTimeClick: () => void;
  onTaskClick: () => void;
  onExpenseClick: () => void;
  onDocFromTemplateClick: () => void;
  toggleDropdown: () => void;
}

const PlusButtonDropdown = ({
  visible,
  onNewMatterClick,
  onNoteClick,
  onTimeClick,
  onTaskClick,
  onExpenseClick,
  onDocFromTemplateClick,
  toggleDropdown,
}: PlusButtonDropdownProps) => {
  const handleMenuItemClick = (callback: () => void) => {
    if (callback) {
      callback();
    }
    toggleDropdown();
  };

  return (
    <div className={`plus-button-dropdown ${visible ? 'visible' : ''}`}>
      <div className='plus-button-dropdown-header'>Create New:</div>
      <ul>
        <li onClick={() => handleMenuItemClick(onNewMatterClick)}>Matter</li>
        <li onClick={() => handleMenuItemClick(onTimeClick)}>Time Entry</li>
        <li onClick={() => handleMenuItemClick(onExpenseClick)}>Expense</li>
        <li onClick={() => handleMenuItemClick(onTaskClick)}>Task</li>
        <li onClick={() => handleMenuItemClick(onNoteClick)}>Note</li>
        <li onClick={() => handleMenuItemClick(onDocFromTemplateClick)}>
          Document
        </li>
      </ul>
    </div>
  );
};

export default PlusButtonDropdown;
